import CustomMaskedInput from 'components/MaskedOutput/index';
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';

interface IProps {
  value: any;
  format?: string;
  disableSymbol?: boolean;
}

class ColoredFormattedNumber extends Component<IProps, any> {
  render() {
    const fmt = this.props.format ? this.props.format : 'BRL';
    return (
      <span className={this.props.value >= 0 ? 'tgreen' : 'tred'}>
        {this.props.disableSymbol ? (
          <CustomMaskedInput mask='money' value={this.props.value} />
        ) : (
          <FormattedNumber value={this.props.value} format={fmt} />
        )}
      </span>
    );
  }
}

export default ColoredFormattedNumber;
